module.exports = __webpack_public_path__ + "static/media/Map.da0a7e4d.png";